var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loaded)?_c('div',{staticClass:"w-full"},[(_vm.client === 'client1tenant')?_c('CWManagePages'):_c('ExpoManagePages',{attrs:{"manager_menu":_vm.manager_menu}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }